import { render, staticRenderFns } from "./MonitoringRegionalAdmin.vue?vue&type=template&id=b358111c&"
import script from "./MonitoringRegionalAdmin.vue?vue&type=script&lang=js&"
export * from "./MonitoringRegionalAdmin.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringRegionalAdmin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports